"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductAreaFilterOptionMap = void 0;
var ProductAreaFilterOptionMap = {
  SectionsAndProductAreas: 0,
  SectionsOnly: 1,
  SpecificProductAreas: 2
};
exports.ProductAreaFilterOptionMap = ProductAreaFilterOptionMap;